import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { NotaDaSostituireDTO } from "../dto/nota-da-sostituireDTO";
import { NotaDaSostituireVO } from "../vo/nota-da-sostituireVO";
import { MapperMetadatiRepertorio } from "./mapper-metadati-repertorio";

@Injectable({ providedIn: "root" })
export class MapperNotaDaSostituire
  implements MapperInterface<NotaDaSostituireDTO, NotaDaSostituireVO> {

  constructor(
    private metadatiRepertorioMapper: MapperMetadatiRepertorio
  ) { }

  convertVoToDto(vo: NotaDaSostituireVO): NotaDaSostituireDTO {
    if (vo != null) {
      const dto = new NotaDaSostituireDTO();
      dto.id = vo.id;
      dto.oggetto = vo.oggetto;
      dto.dataApprovazione = vo.dataApprovazione;
      dto.metadatiRepertorio = this.metadatiRepertorioMapper.convertVoToDto(
        vo.metadatiRepertorio
      );
      return dto || new NotaDaSostituireDTO();
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: NotaDaSostituireDTO): NotaDaSostituireVO {
    if (dto != null) {
      const vo = new NotaDaSostituireVO();
      vo.id = dto.id;
      vo.oggetto = dto.oggetto;
      vo.dataApprovazione = dto.dataApprovazione;
      vo.metadatiRepertorio = this.metadatiRepertorioMapper.convertDtoToVo(
        dto.metadatiRepertorio
      );
      return vo || new NotaDaSostituireVO();
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: NotaDaSostituireVO[]): NotaDaSostituireDTO[] {
    const dtoList = new Array<NotaDaSostituireDTO>();
    voList.forEach((vo) => {
      dtoList.push(this.convertVoToDto(vo));
    });
    return dtoList || new Array<NotaDaSostituireDTO>();
  }

  convertListDtoToVo(dtoList: NotaDaSostituireDTO[]): NotaDaSostituireVO[] {
    const voList = new Array<NotaDaSostituireVO>();
    dtoList.forEach((dto) => {
      voList.push(this.convertDtoToVo(dto));
    });
    return voList || new Array<NotaDaSostituireVO>();
  }
}
